import type { Notifications } from "./api";

export const FOLLOW_UP_NOTE = "It goes only on a weekday morning when you have follow-ups that are due or late.";
export const ISSUE_NOTE = "It goes only on a weekday morning when issues of yours are open for longer than your organization allows.";
export const SIGN_IN_NOTE = "Sign-in links always come by email.";

export type Switch = keyof Notifications;

export const SWITCH_NAMES: Record<Switch, string> = {
  follow_up_mail: "morning follow-up mail",
  issue_reminder_mail: "issue reminder mail",
};

/** The status line after a save of one mail switch (rules Q-35 and I-4). */
export function savedText(next: Notifications, changed: Switch = "follow_up_mail"): string {
  return `Saved: the ${SWITCH_NAMES[changed]} is ${next[changed] ? "on" : "off"}.`;
}

/** Read the days of the issue reminder (rule I-4): a whole number from 0 to max. */
export function parseReminderDays(raw: string, max: number): number | string {
  const value = raw.trim();
  if (!/^\d+$/.test(value) || Number(value) > max) return `Type a whole number of days from 0 to ${max}.`;
  return Number(value);
}

export function reminderText(days: number): string {
  if (days === 0) return "Off: nobody gets an issue reminder mail.";
  return `Each weekday morning, the assignee of an issue that is open for more than ${days} ${days === 1 ? "day" : "days"} gets one reminder mail.`;
}
